import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { Row, Col } from 'react-bootstrap';
import { DataStoreDispatcher } from 'lib/frankly';
import { formatDate } from 'utils/DateUtils';
import LocationSelector from './LocationSelectorV1';
import translate from '../../utils/translate';

class DailyWeatherSummary extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    enableStackView: PropTypes.bool,
    cardOptionValues: PropTypes.array,
    temperatureOptions: PropTypes.shape({
      hideHiTemp: PropTypes.bool,
      hideLoTemp: PropTypes.bool
    })
  }

  static contextTypes = {
    config: PropTypes.object.isRequired,
  }

  static defaultProps = {
    temperatureOptions: {
      hideHiTemp: false,
      hideLoTemp: false
    }
  }

  state = {
    temperatureFormat: 'F'
  }

  componentWillMount() {
    this._weatherDataStoreDispatcher = new DataStoreDispatcher('franklyinc.com/weather');

    this._weatherDataStoreDispatcher.onChange('temperatureFormat', (val) => {
      this.setState({
        temperatureFormat: val
      });
    });
  }

  componentWillUnmount() {
    this._weatherDataStoreDispatcher.off();
    this._weatherDataStoreDispatcher = null;
  }

  _weatherDataStoreDispatcher = null;

  _handleTemperatureFormatClick(format) {
    this._weatherDataStoreDispatcher.set('temperatureFormat', format);
  }

  _setTemperatureFormat(newTempFormat) {
    this._handleTemperatureFormatClick(newTempFormat);
  }

  render() {
    const {
      config: {
        appOptions: {
          language = 'en'
        } = {}
      } = {}
    } = this.context;
    
    const {
      FRN_rawResponses: [
        {
          data: {
            data: weatherData = {}
            } = {}
          } = {}
        ] = [],
      enableStackView,
      cardOptionValues,
      temperatureOptions: {
        hideHiTemp,
        hideLoTemp
      }
    } = this.props;
    const {
      temperatureFormat
    } = this.state;

    const {
      Cities: {
        City: {
          CurrentObservation: currentObservation = null,
          DailyForecast: {
            Day: [dailyForecast = null, ] = []
          } = {}
        } = {}
      } = {}
    } = weatherData;

    if (!currentObservation || !dailyForecast) {
      return null;
    }

    const {
      '@TempF': tempF,
      '@TempC': tempC,
      '@IconCode': iconCode,
      '@Sky': skyText,
      '@Pressure': pressure,
      '@RelHumidity': humidity,
      '@WndSpdMph': windSpeed,
      '@FeelsLikeF': feelsLikeF,
      '@FeelsLikeC': feelsLikeC
    } = currentObservation;

    const {
      '@HiTempF': HiTempF,
      '@HiTempC': HiTempC,
      '@LoTempF': loTempF,
      '@LoTempC': loTempC,
      '@PrecipChance': precipitation,
      '@ValidDateLocal': dateTime,
      '@Sunrise': sunrise,
      '@Sunset': sunset,
      '@Moonrise': moonrise,
      '@Moonset': moonset
    } = dailyForecast;

    const displayTemperature = (temperatureFormat !== 'C') ? tempF : tempC;
    const highTemp = (temperatureFormat !== "C") ? HiTempF : HiTempC;
    const lowTemp = (temperatureFormat !== "C") ? loTempF : loTempC;

    const feelsLike = (temperatureFormat !== 'C') ? feelsLikeF : feelsLikeC;

    const colSpans = {
      xs: 12,
      sm: 4
    };

    if (cardOptionValues) {
      colSpans['sm'] = 12 / cardOptionValues.length;
    }
    if (enableStackView) {
      colSpans['sm'] = 12;
    }

    const cardOptions = {};

    cardOptions['temperature'] = (
      <div className="DailyForecastKeyInformation">
        <div className="DailyForecastKeyInformation-tempDisplay">
          <span className="temperature" >{displayTemperature}</span>
          <div className="DailyForecastKeyInformation-temperatureChoice">
            <span className={'temperature-choice-label line-after' + ((temperatureFormat !== 'C') ? ' active' : '') }
                  dangerouslySetInnerHTML={{ __html: 'F &deg;' }}
                  onClick={this._setTemperatureFormat.bind(this, 'F') }
            />
            <span className={'temperature-choice-label ' + ((temperatureFormat === 'C') ? ' active' : '') }
                  dangerouslySetInnerHTML={{ __html: 'C &deg;' }}
                  onClick={this._setTemperatureFormat.bind(this, 'C') }
            />
          </div>
          <span className={'weather-icon weather-icon-' + iconCode}/>
        </div>
        <div className="DailyForecastKeyInformation-tempDescription">
          <span className="DailyForecastKeyInformation-skyText">{skyText}</span>
        </div>
        <div className="DailyForecastKeyInformation-generalValue">
          {!hideHiTemp && <span className="generalTitle">{translate('L', language)} <span className="infoValue">{lowTemp + '°'}</span></span>}
          {!hideLoTemp && <span className="generalTitle">{translate('H', language)} <span className="infoValue">{highTemp + '°'}</span></span>}
          <span className="weather-percentage weather-precipitation infoValue">{precipitation}</span>
        </div>
      </div>
    );
    cardOptions['meta'] = (
      <div className={`DailyForecastDetailsBlock ${enableStackView ? 'DailyForecastDetailsBlock-marginReset' : null}`}>
        <DetailRow title={translate('Feels Like', language)} value={feelsLike ? feelsLike + '°' : null} />
        <DetailRow title={translate('Humidity', language)} value={humidity} valueClassName={classNames({ 'weather-percentage': humidity })}/>
        <DetailRow title={translate('Pressure', language)} value={pressure} valueClassName={classNames({ 'weather-pressure': pressure })} />
        <DetailRow title={translate('Windspeed', language)} value={windSpeed ? windSpeed + ' mph' : null} />
      </div>
    );
    cardOptions['sunrise'] = (
      <div className={`MeteorologistHourlyforecastMoonSun ${enableStackView ? 'MeteorologistHourlyforecastMoonSun-marginTopReset' : ''}`}>
        <Row>
          <Col xs={6} className="TimeWeatherSun">
            <TimeDetailRow title={translate('Sunrise', language)} validDateLocal={dateTime} value={sunrise} valueClassName="weather-sun sunrise" />
            <TimeDetailRow title={translate('Sunset', language)} validDateLocal={dateTime} value={sunset} valueClassName="weather-sun sunset" />
          </Col>
          <Col xs={6} className="TimeWeatherMoon">
            <TimeDetailRow title={translate('Moonrise', language)} validDateLocal={dateTime} value={moonrise} valueClassName="weather-moon moonrise" />
            <TimeDetailRow title={translate('Moonset', language)} validDateLocal={dateTime} value={moonset} valueClassName="weather-moon moonset" />
          </Col>
        </Row>
      </div>
    );

    let content = [];
    const cardOptionKeys = Object.keys(cardOptions);
    const componentClassNames = classNames(
      'v1-weather-DailyWeatherSummary',
      {
        'v1-weather-DailyWeatherSummary-stacked': enableStackView
      });

    const buildCards = (index, item) => {
      let colClass;

      if (index !== 0 && !enableStackView) {
        colClass = 'v1-weather-DailyWeatherSummary-borderLeft v1-weather-DailyWeatherSummary-marginTop';
      } if (index !== 0 && enableStackView) {
        colClass = 'v1-weather-DailyWeatherSummary-marginTopStackView';
      }

      return (
        <Col key={index} {...colSpans} className={colClass}>
          {item}
        </Col>
      );
    };

    if (cardOptionValues) {
      cardOptionValues.forEach((cardOptionValue, index) => cardOptionKeys.forEach(cardOptionKey => {
        if (cardOptionValue === cardOptionKey) {
          content.push(
            buildCards(index, cardOptions[cardOptionKey])
          );
        }
      }));
    } else {
      content = cardOptionKeys.map((cardOptionKey, index) => {
        return (
          buildCards(index, cardOptions[cardOptionKey])
        );
      });
    }

    return (
      <div className={componentClassNames}>
        <Row>
          <LocationSelector lang={language} backgroundColor="#FFF" textColor="#000" borderColor="#E6E6E6"/>
        </Row>
        <Row className={!enableStackView ? 'v1-weather-DailyWeatherSummary-wrapper' : 'v1-weather-DailyWeatherSummary-viewStack'}>
          {content}
        </Row>
      </div>
    );
  }
}

class DetailRow extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.string,
    valueClassName: PropTypes.string,
    spans: PropTypes.object,
    reverseContent: PropTypes.bool
  }

  static defaultProps = {
    spans: {
      xs: 6
    },
    reverseContent: false
  }

  render() {
    const { title, value, valueClassName, spans, reverseContent } = this.props;

    const content = [
      <Col key={0} {...spans} className="infoTitle">{title}</Col>
    ];

    const infoValue = (<Col key={1} {...spans} className={classNames('infoValue', valueClassName)} >{value || 'N/A'}</Col>);

    if (reverseContent) {
      content.unshift(infoValue);
    } else {
      content.push(infoValue);
    }

    return (
      <Row className="DetailRow">
        {content}
      </Row>
    );
  }
}

class TimeDetailRow extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.string,
    valueClassName: PropTypes.string,
    validDateLocal: PropTypes.string.isRequired
  }

  render() {
    const { validDateLocal, value } = this.props;

    return (
      <DetailRow {...this.props}
        spans={{ xs: 12}} reverseContent
        value={value ? formatDate(validDateLocal.split(' ')[0] + ' ' + value, 'h:mm A') : null } />
    );
  }
}

export default DailyWeatherSummary;



// WEBPACK FOOTER //
// ./app/components/weather/SimpleDailyWeatherSummary.js